/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export default function Link () {
    return {
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
        },
    };
}
